import { RefreshCw } from "lucide-react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

/** "This changed while you were working." Never a silent overwrite: say so, keep the person's
 * edit, and offer the reload (and a compare where the screen can show one). */
export function ConflictBanner({
  onReload,
  onCompare,
  children,
}: {
  onReload: () => void;
  onCompare?: () => void;
  children?: React.ReactNode;
}) {
  return (
    <Alert className="border-warn-bd bg-warn-bg text-foreground" role="alert">
      <RefreshCw aria-hidden className="text-warn" />
      <AlertTitle>This changed while you were working</AlertTitle>
      <AlertDescription>
        <p>{children ?? "Someone else saved a newer version. Your edit is kept below."}</p>
        <div className="mt-2 flex gap-2">
          <Button type="button" size="sm" onClick={onReload}>
            Load the latest
          </Button>
          {onCompare && (
            <Button type="button" size="sm" variant="outline" onClick={onCompare}>
              Compare
            </Button>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
}
